import UUID from "../type/Uuid";

class Project {
    id: UUID = new UUID();
    title: string = '';
    description: string = '';
}

export default Project;